import type { UserT } from '@mentimeter/user';

export const UnauthenticatedUser: UnauthenticatedUserT = Object.freeze({});
export type UnauthenticatedUserT = object;

export function isAuthenticated(user?: ContentUserT): user is UserT {
  return !!user && 'id' in user;
}

export type ContentUserT = UserT | UnauthenticatedUserT;
